<div
    class="icon"
    [style.background-color]="color">
    {{ shortName }}
</div>
